import Vue from 'vue'
import { Button, Icon, Popover, Tooltip, message } from 'ant-design-vue'
import Storage from 'vue-ls'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.use(Storage)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(UserIcon)
Vue.prototype.$message = message
